export default {
  SHARED_FOOTER: {
    WHO_WE_ARE: "Kto sme?",
    LAW_PARTNER: "Náš právny partner",
    LEGAL_BACKGROUND: "Právne pozadie",
    CONTACT: "Kontakt",
    MISSION_STATEMENT: "Našou misiou je uľahčiť a spríjemniť správu pohľadávok, aby spoločnosti mohli udržateľne rásť.",
    COPYRIGHT: "© Copyright {{year}} Legal Labs Ltd. | 1054 Budapešť, Honvéd utca 8. | Registračné číslo spoločnosti: 01-09-382985",
    TOS: "Obchodné podmienky",
    PRIVACY_POLICY: "Politika správy údajov",
    IMPRINT: "Imprint",
  },
};